<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 28.3.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<svg version="1.1" id="Lag_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve" width="40" height="40" >
	<style type="text/css">
		.st0{opacity:0.50;}
		.st1{opacity:0.75;}
	</style>
	<g>
		<path class="st0 spiderIcon" d="M2.7,30c-3.6-6.2-3.6-13.8,0-20S12.9,0,20,0s13.7,3.8,17.3,10c3.6,6.2,3.6,13.8,0,20C33.7,36.2,27.1,40,20,40
			S6.3,36.2,2.7,30z"/>
		<path class="st1 spiderIcon" d="M13.5,16.3c-1.3,2.3-1.3,5.2,0,7.5s3.8,3.7,6.5,3.7s5.2-1.4,6.5-3.7s1.3-5.2,0-7.5s-3.8-3.7-6.5-3.7
			S14.8,13.9,13.5,16.3z"/>
	</g>
</svg>